import { Component, SimpleChanges } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';

import { ComponentBase } from '@framework/base/component';
import { CoreState } from '@app/store/core/states';
import { storySelector } from '@modules/story/store/selectors';
import { StoryViewModel, StepDataItemViewModel } from '@modules/story/models/view-models';
import { Constants } from '@modules/shared/constants';
import { UtilityHelper } from '@framework/utilities';
import { StoryLoadStatusViewModel } from "@modules/story/models/store-view-models";
import { storyActions } from '@modules/story/store/actions';

@Component({
  selector: 'app-pb-steps-bar',
  templateUrl: './steps-bar.component.html',
  styleUrls: ['./steps-bar.component.scss']
})
export class StepsBarComponent extends ComponentBase {
  // Private variables
  private selectStoryDetail$: Observable<StoryViewModel>;
  private selectStatusDetail$: Observable<StoryLoadStatusViewModel>;

  private selectStoryDetailSubscription: Subscription;
  private selectStatusDetailSubscription: Subscription;
  // Public variables
  public storyDetail: StoryViewModel;
  public statusDetail: StoryLoadStatusViewModel;
  public display_maccalie_tags:boolean = true;
  public clickedHearts: Set<string> = new Set(); // Track hearts clicked in current session

  constructor(private store$: Store<CoreState>, private utility: UtilityHelper) {
    super();

    this.selectStoryDetail$ = this.store$.select(storySelector.selectCurrentStory);
    this.selectStatusDetail$ = this.store$.select(storySelector.selectLoadStatus);
  }

  // Life cycle hook
  protected onInit(): void {
    this.subscribe();
  }
  protected onDestroy(): void {
    this.unsubscribe();
  }
  protected onChanges(changes: SimpleChanges): void {

  }
  protected onDoCheck(): void {

  }
  protected onAfterContentInit(): void {

  }
  protected onAfterContentChecked(): void {

  }
  protected onAfterViewInit(): void {

  }
  protected onAfterViewChecked(): void {

  }
  // Private functions
  private subscribe() {
    this.selectStoryDetailSubscription = this.selectStoryDetail$.subscribe((storyDetail) => {
      this.storyDetail = storyDetail;
      if(this.storyDetail && this.storyDetail?.stepsData && Object.keys(this.storyDetail.stepsData).includes('17')){
        delete this.storyDetail.stepsData[17]
      }
      if(this.storyDetail && this.storyDetail.company && this.storyDetail.company.companyId == 1602){
        this.display_maccalie_tags = false;
       }
      this.mapCount()
    });

    this.selectStatusDetailSubscription = this.selectStatusDetail$.subscribe((statusDetail) => {
      this.statusDetail = statusDetail;
    });
  }

  private unsubscribe() {
    this.selectStoryDetailSubscription.unsubscribe();
    this.selectStatusDetailSubscription.unsubscribe();
  }
  // Public functions
  public getStepIcon(name: string) {
    return Constants.stepIcon.getStepIcon(name.split(' ').join(''));
  }
  
  public likeTag(item, e) {
    item.count = (item.count ? item.count : 0) + 1;
    this.clickedHearts.add(item.idOrSlug); // Track this heart as clicked
    
    // Also update the tagsCountData array for the total likes counter
    if (this.storyDetail?.tagsCountData) {
      const tagCountItem = this.storyDetail.tagsCountData.find(tag => tag.tagId == item.idOrSlug);
      if (tagCountItem) {
        tagCountItem.count = (Number(tagCountItem.count) || 0) + 1;
      } else {
        // If tag doesn't exist in tagsCountData, add it
        this.storyDetail.tagsCountData.push({
          tagId: item.idOrSlug,
          count: 1
        } as any);
      }
    }
    
    // Find the step data to get the color
    const stepData = this.getStepsData().find(step => 
      step.data && step.data.some(dataItem => dataItem.idOrSlug === item.idOrSlug)
    );
    const tagColor = stepData ? stepData.color : null;
    
    this.pop(e, item.idOrSlug, tagColor);
    this.store$.dispatch(new storyActions.LikeStoryTag({ storyId: this.storyDetail.id, tagId: item.idOrSlug }));
  }

  public isHeartClicked(item): boolean {
    return this.clickedHearts.has(item.idOrSlug);
  }

  public mapCount() {
    if(this.storyDetail?.stepsData)
    {
      const keys = this.getKeys(this.storyDetail.stepsData);
      keys.forEach(key => {
        if (this.storyDetail.stepsData[key].data && this.storyDetail.stepsData[key].data.length)
          this.storyDetail.stepsData[key].data.forEach(step => {
            step.count = this.getCount(step);
          })
      })
    }

  }

  public getKeys(arr): Array<string> {
    if (!arr) return [];
    return Object.keys(arr);
  }

  public getCount(item) {
    let count = 0;
    this.storyDetail.tagsCountData.forEach(tag => {
      if (tag.tagId == item.idOrSlug) {
        count = tag.count;
      }
    })
    return count;
  }
  public getStepsData() {
    const data: StepDataItemViewModel[] = [];

    this.utility.Lodash.forEach(this.storyDetail && this.storyDetail.stepsData || [], (value, key) => {
      data.push(value);
    });

    return data;
  }

  public getCssClass(stepData: StepDataItemViewModel) {
    return `l-story-tags__item l-story-tags__item--${stepData.title.toLowerCase()}`;
  }



  public pop(e, id, tagColor?: string) {
    var element = document.getElementById('countBadge' + id);
    element.classList.add("animate-like");
    setTimeout(() => {
      var element = document.getElementById('countBadge' + id);
      element.classList.remove("animate-like");
    }, 500);
    let amount = 30;
    switch (e.target.dataset.type) {
      case 'shadow':
      case 'line':
        amount = 60;
        break;
    }
    // Quick check if user clicked the button using a keyboard
    if (e.clientX === 0 && e.clientY === 0) {
      const bbox = e.target.getBoundingClientRect();
      const x = bbox.left + bbox.width / 2;
      const y = bbox.top + bbox.height / 2;
      for (let i = 0; i < 30; i++) {
        // We call the function createParticle 30 times
        // We pass the coordinates of the button for x & y values
        this.createParticle(x, y, e.target.dataset.type, tagColor);
      }
    } else {
      for (let i = 0; i < amount; i++) {
        this.createParticle(e.clientX, e.clientY + window.scrollY, e.target.dataset.type, tagColor);
      }
    }
  }
  createParticle(x, y, type, tagColor?: string) {
    const particle = document.createElement('particle');
    document.body.appendChild(particle);
    let width: any = Math.floor(Math.random() * 30 + 8);
    let height: any = width;
    let destinationX = (Math.random() - 0.5) * 300;
    let destinationY = (Math.random() - 0.5) * 300;
    let rotation = Math.random() * 520;
    let delay = Math.random() * 100;

    // Use tag color if provided, otherwise use default random colors
    var color;
    if (tagColor) {
      // Create variations of the tag color
      const hue = this.hexToHsl(tagColor).h;
      const saturation = 70 + Math.random() * 20; // 70-90%
      const lightness = 45 + Math.random() * 20;  // 45-65%
      color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    } else {
      color = `hsl(${Math.random() * 90 + 90}, 70%, 50%)`;
    }
    
    particle.style.boxShadow = `0 0 ${Math.floor(Math.random() * 10 + 10)}px ${color}`;
    particle.style.background = color;
    particle.style.borderRadius = '50%';
    width = height = Math.random() * 5 + 4;

    particle.style.width = `${width}px`;
    particle.style.height = `${height}px`;
    const animateArr: any = [
      {
        transform: `translate(-50%, -50%) translate(${x}px, ${y}px) rotate(0deg)`,
        opacity: 1
      },
      {
        transform: `translate(-50%, -50%) translate(${x + destinationX}px, ${y + destinationY}px) rotate(${rotation}deg)`,
        opacity: 0
      }
    ]
    const animateObj: any = {
      duration: Math.random() * 1000 + 2000,
      easing: 'cubic-bezier(0, .9, .57, 1)',
      delay: delay
    }

    const animation = particle.animate(animateArr, animateObj);
    animation.onfinish = this.removeParticle;
  }

  // Helper function to convert hex color to HSL
  private hexToHsl(hex: string): {h: number, s: number, l: number} {
    // Remove # if present
    hex = hex.replace('#', '');
    
    // Convert hex to RGB
    const r = parseInt(hex.substr(0, 2), 16) / 255;
    const g = parseInt(hex.substr(2, 2), 16) / 255;
    const b = parseInt(hex.substr(4, 2), 16) / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max === min) {
      h = s = 0; // achromatic
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
        default: h = 0;
      }
      h /= 6;
    }

    return {
      h: Math.round(h * 360),
      s: Math.round(s * 100),
      l: Math.round(l * 100)
    };
  }
  removeParticle(e) {
    e.srcElement.effect.target.remove();
  }
}
